// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const audino: PokeData = {
  "id": 531,
  "name": "audino",
  "height": 11,
  "weight": 310,
  "base_experience": 390,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "take-down",
    "double-edge",
    "growl",
    "attract",
    "helping-hand",
    "refresh",
    "secret-power",
    "hyper-voice",
    "last-resort",
    "zen-headbutt",
    "simple-beam",
    "entrainment",
    "after-you",
    "heal-pulse",
    "disarming-voice",
    "misty-terrain",
    "play-nice",
    "baby-doll-eyes",
    "life-dew"
  ],
  "moves": [
    "growl",
    "refresh",
    "hyper-voice",
    "zen-headbutt",
    "misty-terrain",
    "life-dew",
    "tri-attack",
    "quick-attack",
    "body-slam",
    "purification",
    "splash",
    "protect",
    "scratch"
  ],
  "evolution_chain": {
    "id": 271,
    "item": null,
    "species": [
      {
        "name": "audino",
        "order": 532,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 185,
    "speed": 98,
    "ability_power": 117
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
